import _ from 'lodash';
import { API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_SUCCESS } from '../actions/ProffitSearchAction';
import { API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME_SUCCESS } from '../actions/ProffitSearchFolderAction';
import { API_CREATE_PROFFIT_SEARCH_SLIDE_SELECT, API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT, API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT_ALL, } from '../actions/ProffitSearchSelectAction';
import { slideSearchPageHelper } from '../helpers/page/SlideSearch';
/**
 * スライドサーチの選択状態を切り替える
 * @param state
 * @param callback
 * @returns {*&{selectSlide: {}}}
 */
const updateSelectSlide = (state, callback) => {
    const { selectSlide = [] } = state;
    return Object.assign(Object.assign({}, state), { selectSlide: callback(selectSlide) });
};
// eslint-disable-next-line default-param-last
export default (state = {}, { meta, payload, type }) => {
    switch (type) {
        // 詳細情報取得
        case API_GET_PROFFIT_SEARCH_SLIDE_INFORMATION_SUCCESS: {
            return Object.assign({}, payload);
        }
        // スライドを選択状態に更新（複数）
        case API_CREATE_PROFFIT_SEARCH_SLIDE_SELECT: {
            const listKey = slideSearchPageHelper.getRequestKeyFromUnitValue(meta.key);
            return updateSelectSlide(state, (array) => 
            // 検索結果に表示されているスライドを取得+結合し、idで重複を排除する
            _.uniqBy([...array, ...meta[listKey]], (v) => v.slideSearchSlidePageUuid || v.slideSearchSlideUuid));
        }
        // スライドの選択状態を解除
        case API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT: {
            const listKey = slideSearchPageHelper.getRequestKeyFromUnitValue(meta.key);
            return updateSelectSlide(state, (array) => array.filter((v) => !meta.idList.includes(v[listKey])));
        }
        // スライドの選択状態を全解除
        case API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT_ALL: {
            return updateSelectSlide(state, () => []);
        }
        // フォルダ名が更新されたら書き換える
        case API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME_SUCCESS: {
            const { id, name } = meta;
            const folders = (state.folders || []).map((v) => v.id === id ? Object.assign(Object.assign({}, v), { name }) : v);
            return Object.assign(Object.assign({}, state), { folders });
        }
        default: {
            return state;
        }
    }
};
